import React, { useEffect, useState } from "react";
import { MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";
import { Buttons } from "app/constants/sizing";
import { ColorsV2 } from "app/constants/color";
import { useSwapToken } from "app/utils/hooks/useSwapToken";

const OrgSelector = () => {
  const swapToken = useSwapToken();
  const orgs = useSelector((state) => state.orgSelect.orgs);
  const {selectedOrgId, selectedOrgName} = useSelector((state) => state.orgSelect);
  const [curOrg, setCurOrg] = useState({id: null, name: ""});

  useEffect(() => {
    setCurOrg({id: selectedOrgId, name: selectedOrgName});
  }, [selectedOrgId, selectedOrgName]);

  const handleSelect = (e) => {
    const newOrg = e.target.value;
    const orgId = newOrg.id || "";
    swapToken(orgId);
  };

  return(
    orgs && orgs.length > 1 ?
    <>
      <Select
      variant='outlined'
      onChange={handleSelect}
      value={curOrg}
      renderValue={(value) => value.name}
      sx={{
        ...Buttons.baseStyle.selectLowPriority,
        color: ColorsV2.white,
      }}
      >
        <MenuItem value="" disabled>
            Select an organisation
        </MenuItem>
        {orgs.map((org) => {
            return(
                <MenuItem key={org.id} value={{id: org.id, name: org.name}}>{org.name}</MenuItem>
            )
        })}
      </Select>
    </>
    :
    null
  )
};

export default OrgSelector;